import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractBinaryOperatorFormulaToken from "./AbstractBinaryOperatorFormulaToken.js";
import SubtractionFormulaNode from "../formula/SubtractionFormulaNode.js";

/**
 * Binary operation token representing a mathematical subtraction.
 */
export default class SubtractionFormulaToken extends AbstractBinaryOperatorFormulaToken {
	accept(visitor) {
		return visitor.visitSubtractionFormulaToken(this);
	}

	_formulaNodeConstructor() {
		return SubtractionFormulaNode;
	}

	static getLabel() {
		return _("Subtraction");
	}

	static getType() {
		return "subtraction";
	}
}
